import * as CLOUD_API from "@skydio/api_util/src/backends/cloud_api";
import { OrgTier } from "@skydio/pbtypes/pbtypes/tools/cloud_api/enums_pb";

import type { ValueType } from "@skydio/core";

const { orgTierEnum } = CLOUD_API.modules.organizations.utils;

export type ReadableOrgTier = {
  readableName: string;
  enumValue: string | ValueType<OrgTier.OrgTierEnumMap>;
  enumStringName: string;
};

const readableOrgTierMap: Partial<Record<ValueType<OrgTier.OrgTierEnumMap>, string>> = {
  [orgTierEnum.UNKNOWN]: "Unknown",
  [orgTierEnum.EMPLOYEE]: "Employee",
  [orgTierEnum.BETA]: "Beta",
  [orgTierEnum.T3]: "Tier 3",
  [orgTierEnum.T2]: "Tier 2",
  [orgTierEnum.T1]: "Tier 1",
  [orgTierEnum.PROTECTED]: "Protected",
};

export const getReadableOrgTierFromName = (tier: string) => {
  if (tier in OrgTier.OrgTierEnum) {
    return readableOrgTierMap[OrgTier.OrgTierEnum[tier as keyof typeof OrgTier.OrgTierEnum]] || "";
  }
  return "";
};

export const getReadableOrgTierFromValue = (value: ValueType<OrgTier.OrgTierEnumMap>) =>
  readableOrgTierMap[value] || "";

export const getReadableOrgTiers = () =>
  Object.entries(orgTierEnum).map(
    ([key, value]) =>
      ({
        readableName: getReadableOrgTierFromValue(value as ValueType<OrgTier.OrgTierEnumMap>),
        enumValue: value,
        enumStringName: key,
      }) as ReadableOrgTier
  );
